export const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;

export const formatDisplayNumber = (value) => {
  return !isNaN(value) ? value.toLocaleString() : "";
};

export const formatPercentage = (value, total, maximumFractionDigit = 0) => {
  if (isNaN(value)) {
    return "";
  }

  if (value === 0) {
    return "0%";
  }

  var ratio = (value / total) * 100;

  return !isNaN(value)
    ? ratio.toLocaleString(undefined, {
        maximumFractionDigits: maximumFractionDigit,
      }) + "%"
    : "";
};

export const formatCallPercentages = (value) => {
  if (isNaN(value)) return "";
  if (value === 0) return "0%";
  return !isNaN(value) ? value + "%" : "";
};
